module.exports = __webpack_public_path__ + "static/media/MAINTAIN 3.0261ef48.svg";